import React from 'react'
import { useState, useEffect } from "react";
import { GetYoutube } from './youtube-service';
import { PostApi } from '../../services/CommonService2';
import YouTube from "react-youtube";
function Youtube(props) {
    const [youtubeData, setYoutubeData] = useState([])
    useEffect(() => {

        getYoutubeVideo()
    }, [props.subapllicationid])
    const getYoutubeVideo = async () => {
        console.log(props, "fron youtube videos")
        const reqdata = {
            pageno: '-1',
            query: { status: 'Active' },


        }
        try {
            const data = await PostApi(reqdata, 'YOUTUBEVIDEOS', props.subapllicationid)

            setYoutubeData(data.data)
        } catch (error) {
            console.log(error)
        }
    }
    const opts = {
        width: "100%",
        borderRadius: "2rem",
        playerVars: { autoplay: 0 },
        height: "200px"
    };
    const videoReady = (event) => {
        event.target.pauseVideo();
    };
    return (
        <div className='col-sm-12 col-md-6 col-lg-4 my-5' style={{ maxHeight: "520px", overflowY: "scroll" }}>
            <div className="card " style={{
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                transition: 'box-shadow 0.3s ease-in-out',
                borderRadius: '12px'
            }}>
                <div className="card-header bg-danger px-4 py-3" style={{ borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
                    <p className='text-light fs-3'><b>Youtube Videos</b></p>
                </div>
                {/* {console.log(youtubeData,"check youtube data")} */}
                <ul className="list-group list-group-flush">

                    {

                        youtubeData?.map(ele => {
                            return (
                                <>

                                    <li className="list-group-item list-group-item-action p-3">
                                        <div
                                            style={{
                                                borderRadius: "10px",       
                                                overflow: "hidden",         
                                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.57)",
                                                transition: "box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out",
                                            }}
                                        >
                                            <YouTube
                                                videoId={ele.name}
                                                opts={opts}
                                                onReady={videoReady}
                                                style={{ display: "block", width: "100%" }}
                                            />
                                        </div>
                                    </li>



                                </>
                            )
                        })
                    }

                </ul>
            </div>
        </div>
    )
}

export default Youtube